// constants.ts

export const NAME = 'priceCatalog';